import React from 'react';
import { useMutation } from '@apollo/client';
import MakePaymentMutation from './MakePaymentMutation';
import { MakePaymentArguments } from './types';

interface IMakePaymentConnectorApollo {
  children: ({
    makePayment,
  }: {
    makePayment: (args: MakePaymentArguments) => Promise<unknown>;
  }) => React.ReactElement;
}

const MakePaymentConnectorApollo: React.FC<IMakePaymentConnectorApollo> = ({ children }) => {
  const [makePayment] = useMutation(MakePaymentMutation);

  const createMakePayment = async (args: MakePaymentArguments) => {
    const response = await makePayment({
      variables: {
        token: args.token,
        methodId: args.methodId,
        channelId: args.channelId,
        successUrl: args.successUrl,
        cancelUrl: args.cancelUrl,
      },
    });

    return response;
  };

  return children({ makePayment: createMakePayment });
};

export default MakePaymentConnectorApollo;
